export const FOOTER_CONTACT = {
  EMAIL: 'contact@kimeraware.com',
  COMPANY_NAME: 'KIMERAWARE LLC',
  YEAR: '2026',
} as const;

export const FOOTER_ACCESSIBILITY = {
  FOOTER_REGION: 'contentinfo',
  EMAIL_LINK_ROLE: 'link',
} as const;